import { useStore as getStore } from "../../utils/useStore.js";
import mailFactory from "./mailFactory.js";
import queryString from "query-string";

const { contributor } = queryString.parse(window.location.search);

export const initialState = () => ({
  status: "",
  sender: { Email: "", Name: "", Subscription: null, brandedHeader: "" },
  fileId: "",
  mailId: "",
  isCollection: false,
  security: {
    IsSharingDisabled: false,
    IsPasswordProtected: false,
    DownloadLimit: 0,
  },
  alertToUser: [],
  userPasswordInput: "",
  metaData: {
    ShortUrl: "",
    filesCount: 0,
    RecipientsList: "",
    Expiration: "",
    Creation: "",
    CSRFToken: "",
    IsVideoTranscoded: "",
    TotalSize: 0,
    DownloadsCount: "",
    ShareCount: "",
    subjectText: "",
    bodyText: "",
    CommentCount: 0,
  },
  userVideoToken: "",
  payment: {
    Price: 0,
    Currency: "",
    PaymentType: "",
    DenyPreview: false,
    DisplayName: "",
    SuccessfulPurchasesCount: 0,
  },
  sorting: {
    by: "Name",
    asc: true,
  },
  backgroundCover: "",
  backgroundCoverFileId: 0,
  pageNumber: 1,
  filesLoading: true,
  filesData: {},
  filesDataErrorMessage: "",
  filesOrderedList: [],
  folderStructured: null,
  searchParam: "",
  searchExpectedFiles: null,
  preventFetching: false,
  contributorsFilter: contributor ? [contributor.replace("%40", "@")] : [],
  contributorsData: {},
  dataInUse: false,
  foldersData: {},
  foldersList: [],
  currentFolder: null,
  collectionsData: {},
  currentCollection: null,
  isDisplayAllowed: true,
});

const [MailProvider, useMail, withMail] = getStore(
  mailFactory,
  initialState,
  "Mail"
);

export const mailInitState = initialState();

export { useMail, MailProvider, withMail };

export default MailProvider;
